/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPackage
 */
export interface SubscriptionPackage {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPackage
     */
    name?: string;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionPackage
     */
    maxUsers?: number;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionPackage
     */
    maxIntegrations?: number;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionPackage
     */
    maxDomains?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    dataUpdatesPerDay?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    isPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    isDefault?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    monthlyCzk?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    yearlyCzk?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    monthlyEur?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    yearlyEur?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    allowDiscountCodeEvaluation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    allowInfluencerEvaluation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    allowAffiliateEvaluation?: boolean;
    /**
     * 
     * @type {any}
     * @memberof SubscriptionPackage
     */
    id?: any | null;
}

/**
 * Check if a given object implements the SubscriptionPackage interface.
 */
export function instanceOfSubscriptionPackage(value: object): value is SubscriptionPackage {
    return true;
}

export function SubscriptionPackageFromJSON(json: any): SubscriptionPackage {
    return SubscriptionPackageFromJSONTyped(json, false);
}

export function SubscriptionPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPackage {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'maxUsers': json['maxUsers'] == null ? undefined : json['maxUsers'],
        'maxIntegrations': json['maxIntegrations'] == null ? undefined : json['maxIntegrations'],
        'maxDomains': json['maxDomains'] == null ? undefined : json['maxDomains'],
        'dataUpdatesPerDay': json['dataUpdatesPerDay'] == null ? undefined : json['dataUpdatesPerDay'],
        'isPublic': json['isPublic'] == null ? undefined : json['isPublic'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'monthlyCzk': json['monthlyCzk'] == null ? undefined : json['monthlyCzk'],
        'yearlyCzk': json['yearlyCzk'] == null ? undefined : json['yearlyCzk'],
        'monthlyEur': json['monthlyEur'] == null ? undefined : json['monthlyEur'],
        'yearlyEur': json['yearlyEur'] == null ? undefined : json['yearlyEur'],
        'allowDiscountCodeEvaluation': json['allowDiscountCodeEvaluation'] == null ? undefined : json['allowDiscountCodeEvaluation'],
        'allowInfluencerEvaluation': json['allowInfluencerEvaluation'] == null ? undefined : json['allowInfluencerEvaluation'],
        'allowAffiliateEvaluation': json['allowAffiliateEvaluation'] == null ? undefined : json['allowAffiliateEvaluation'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function SubscriptionPackageToJSON(json: any): SubscriptionPackage {
    return SubscriptionPackageToJSONTyped(json, false);
}

export function SubscriptionPackageToJSONTyped(value?: SubscriptionPackage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'maxUsers': value['maxUsers'],
        'maxIntegrations': value['maxIntegrations'],
        'maxDomains': value['maxDomains'],
        'dataUpdatesPerDay': value['dataUpdatesPerDay'],
        'isPublic': value['isPublic'],
        'isDefault': value['isDefault'],
        'monthlyCzk': value['monthlyCzk'],
        'yearlyCzk': value['yearlyCzk'],
        'monthlyEur': value['monthlyEur'],
        'yearlyEur': value['yearlyEur'],
        'allowDiscountCodeEvaluation': value['allowDiscountCodeEvaluation'],
        'allowInfluencerEvaluation': value['allowInfluencerEvaluation'],
        'allowAffiliateEvaluation': value['allowAffiliateEvaluation'],
        'id': value['id'],
    };
}

